import {Outlet, useLocation} from "react-router-dom";

const PayrollRoute = () => {
    const location = useLocation();
    const routeWidths = [
        {path: 'payrole/manage-salary'},
        // {path: 'configuration/manage-departments/add'},
        // {path: 'configuration/manage-designations/add'},
    ];
    // const currentWidth = routeWidths.find(route => location.pathname.includes(route.path)) || 'auto';
    const currentWidth = location.pathname.split("/").some(item=>(["edit", "add"]).includes(item)) || 'auto';

    return (
        <div className={"p-4"}>
            <div
                className={` h-[calc(100vh-96px)] overflow-y-auto 
                ${currentWidth === '100%' ? '' : ''}`}
            >
                <Outlet/>
            </div>
        </div>
    );
}

export default PayrollRoute;
